/**
 * @providesModule TournamentManager
 * 
 */

import React from 'react';

import _ from 'lodash';
import ErrorDialogModal from 'ErrorDialogModal';
import LoadingIndicator from 'LoadingIndicator';
import ModalNavigationController from 'ModalNavigationController';
import RESTStore from 'RESTStore';
import SKZTournament from 'SKZTournament';

import {
  NativeModules,
  Platform,
} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

export default class TournamentManager {
  static Error = {
    INVALID_MATCH_CODE: 'invalid match code',
  };

  // MATCH CODES

  static fetchTournamentForCode(matchCode:string, allowUnstarted: boolean, skipError: boolean, completion: (error?: string, tournament?: SKZTournament) => void) {
    LoadingIndicator.showWithText('', LoadingIndicator.Style.NoIcon);
    const promptRetry = Platform.OS == 'ios' ? SKZAPIManager.OnError.failSilently : false;
    const params = {
      matchCode: matchCode,
      allowUnstarted: allowUnstarted ? 'true' : 'false',
    };
    RESTStore.getServerResponse('tournaments/', params, promptRetry,
      (payload: Object, error: string) => {
        LoadingIndicator.hide();
        if (error) {
          if (skipError) {
            const errorResponse = _.get(error, 'responseObject');
            const errorMessage = TournamentManager._getErrorMessageFromError(errorResponse);
            completion(errorMessage, null);
          } else {
            TournamentManager._handleMatchCodeError(error, completion, TournamentManager.fetchTournamentForCode.bind(this, matchCode, allowUnstarted, skipError, completion));
          }
        } else {
          console.debug('match code fetch success:' + JSON.stringify(payload));
          if (payload && payload instanceof Array && payload.length && payload[0].id) {
            const tournament = new SKZTournament(payload[0]);
            if (!tournament) {
              completion(TournamentManager.Error.INVALID_MATCH_CODE, null);
            } else {
              completion(null, tournament);
            }
          } else {
            completion(TournamentManager.Error.INVALID_MATCH_CODE, null);
          }
        }
      }
    );
  }

  static _getErrorMessageFromError(error: unknown): string {
    if (Array.isArray(error) && error.length) {
      const errorObj = _.head(error);

      return _.get(errorObj, 'message');
    }

    return _.get(error, 'message');
  }

  static _handleMatchCodeError(error: Object, onCancel: (error?: string, tournament?: SKZTournament)=>void, onRetry: (error?: string, tournament?: SKZTournament)=>void) {
    const errorResponse = _.get(error, 'responseObject');
    const errorMessage = TournamentManager._getErrorMessageFromError(errorResponse);
    console.debug('TournamentManager: error for match code: ' + JSON.stringify(errorMessage));

    const modal = (
      <ErrorDialogModal message={errorMessage}
                        error={error}
                        onCancel={() => { onCancel(errorMessage, null); }}
                        retryCallback={onRetry}
                        onDone={():void => ModalNavigationController.hideModal()} />
    );

    ModalNavigationController.showModal(modal);
  }
}
